var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 7C17.7761 7 18 6.77614 18 6.5V3.5C18 3.22386 17.7761 3 17.5 3H6.5C6.22386 3 6 3.22386 6 3.5V20.5C6 20.7761 6.22386 21 6.5 21H17.5C17.7761 21 18 20.7761 18 20.5V17.5C18 17.2239 17.7761 17 17.5 17H16.5C16.2239 17 16 17.2239 16 17.5V19H8V5H16V6.5C16 6.77614 16.2239 7 16.5 7H17.5ZM11.5015 13H18V14C18 14.1082 18.0351 14.2135 18.1 14.3C18.2657 14.5209 18.5791 14.5657 18.8 14.4L21.4667 12.4C21.5046 12.3716 21.5382 12.3379 21.5667 12.3C21.7324 12.0791 21.6876 11.7657 21.4667 11.6L18.8 9.6C18.7135 9.53509 18.6082 9.5 18.5 9.5C18.2239 9.5 18 9.72386 18 10V11H11.5015C11.2245 11 11 11.214 11 11.5047V12.4953C11 12.774 11.2197 13 11.5015 13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.996757b107b8aadc5b4d8eaf19e15cff.svg";
export { ForwardRef as ReactComponent };